import { useState } from "react";
import { Check } from "lucide-react";
import Dropdown from "components/dropdown";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n/config";
import { LANGUAGE } from "../../types";
import gbFlag from "../../assets/img/flag/GB.png";
import vnFlag from "../../assets/img/flag/VN.png";

type Language = LANGUAGE.ENGLISH | LANGUAGE.VIETNAMESE;

export function ChangeLanguage() {
  const { t, i18n: i18nInstance } = useTranslation();
  const [openDropdown, setOpenDropdown] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState<Language>(
    (i18nInstance.language === "en" ? LANGUAGE.ENGLISH : LANGUAGE.VIETNAMESE) ||
      LANGUAGE.ENGLISH
  );

  const languages = [
    {
      code: LANGUAGE.ENGLISH as Language,
      label: t("language.english"),
      flag: gbFlag,
      flagAlt: "EN",
    },
    {
      code: LANGUAGE.VIETNAMESE as Language,
      label: t("language.vietnamese"),
      flag: vnFlag,
      flagAlt: "VI",
    },
  ] as const;

  const handleLanguageChange = async (languageCode: Language) => {
    try {
      await i18n.changeLanguage(
        languageCode === LANGUAGE.ENGLISH ? "en" : "vi"
      );
      setCurrentLanguage(languageCode);
      setOpenDropdown(false);
      localStorage.setItem(
        "language",
        languageCode === LANGUAGE.VIETNAMESE ? "vi" : "en"
      );
    } catch (error) {
      console.error("Error updating language:", error);
    }
  };

  const currentLang = languages.find((lang) => lang.code === currentLanguage);

  return (
    <Dropdown
      setIsOpen={setOpenDropdown}
      isOpen={openDropdown}
      button={
        <div className="flex w-max cursor-pointer items-center gap-2 rounded-lg p-2 transition-colors duration-200 hover:bg-gray-100 dark:hover:bg-navy-700">
          {currentLang && (
            <img
              src={currentLang.flag}
              alt={currentLang.flagAlt}
              className="h-5 w-7 rounded object-cover shadow-sm"
            />
          )}
        </div>
      }
      classNames={"py-2 top-12 w-max right-2"}
    >
      <div className="flex w-48 flex-col overflow-hidden rounded-xl border border-gray-100 bg-white shadow-xl dark:border-navy-600 dark:bg-navy-700">
        <div className="border-b border-gray-100 px-4 py-3 dark:border-navy-600">
          <h3 className="text-sm font-bold text-navy-700 dark:text-white">
            {t("language.select")}
          </h3>
        </div>
        <div className="py-2">
          {languages.map((language) => (
            <button
              key={language.code}
              onClick={() => handleLanguageChange(language.code)}
              className="flex w-full items-center justify-between px-4 py-2 text-sm text-gray-700 transition-colors duration-150 hover:bg-gray-50 dark:text-gray-200 dark:hover:bg-navy-600"
            >
              <div className="flex items-center gap-3">
                <img
                  src={language.flag}
                  alt={language.flagAlt}
                  className="h-5 w-7 rounded object-cover shadow-sm"
                />
                <span className="font-medium">{language.label}</span>
              </div>
              {currentLanguage === language.code && (
                <Check className="h-4 w-4 text-blue-600 dark:text-blue-400" />
              )}
            </button>
          ))}
        </div>
      </div>
    </Dropdown>
  );
}
